module.exports = __webpack_public_path__ + "img/city_trees.669d1d38.png";